module.exports = __webpack_public_path__ + "static/media/engfood-round.59246fb2.png";